import React from 'react'
import { compose } from 'recompose'
import { withGoogleMap, GoogleMap as ReactGoogleMap } from 'react-google-maps'
import Marker from './Marker'
import MarkerTracker from './MarkerTracker'
import { TRACKERTYPES } from 'utils/constants'

const GoogleMap = compose(withGoogleMap)(({ geo,type }) => {
  console.log('In google map' + JSON.stringify(type))
  if (TRACKERTYPES.includes(type) || type == 'pack') {
    return (
      <ReactGoogleMap
        center={{ lat: Number(geo[0].lat), lng: Number(geo[0].lng) }}
        options={{
          streetViewControl: false,
          fullscreenControl: true,
          gestureHandling: 'cooperative',
          zoom: 18,
        }}
      >
        <MarkerTracker loc={geo} />
      </ReactGoogleMap>
    )
  }
  else {

    return (
      <ReactGoogleMap
        center={{ lat: geo.latitude, lng: geo.longitude }}
        options={{
          streetViewControl: false,
          fullscreenControl: true,
          gestureHandling: 'cooperative',
          zoom: 18,
        }}
      >
        <Marker loc={geo} />
      </ReactGoogleMap>
    )
  }
})

export default GoogleMap

